module.exports = "/_next/static/images/b075aee1efd269a7681c16a768429398-hero-variant-b-mobile.jpg.webp";